import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme: any) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  text: { fontSize: '1.8em', maxWidth: 600, textAlign: 'center' },
  icon: {
    fontSize: theme.spacing(10),
    marginTop: theme.spacing(2),
  },
  warningIcon: { color: theme.palette.brand.orange },
  successIcon: { color: theme.palette.status.active },
}));

export default function Message({ text, warning = true, icon = true }) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {icon && warning && (
        <NotificationsActiveIcon
          className={classes.icon + ' ' + classes.warningIcon}
        />
      )}
      {icon && !warning && (
        <ThumbUpIcon color="primary" className={classes.icon} />
      )}
      <Typography className={classes.text}>{text}</Typography>
    </div>
  );
}
